'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _RequestStatusTypes = require('conversations-schema/constants/RequestStatusTypes');

var RequestStatusTypes = _interopRequireWildcard(_RequestStatusTypes);

var _ChatHeadingConfigPropType = require('ui-addon-conversations/chat-heading-config/prop-types/ChatHeadingConfigPropType');

var _ChatHeadingConfigPropType2 = _interopRequireDefault(_ChatHeadingConfigPropType);

var _getThreads = require('../threads/selectors/getThreads');

var _getThreadList = require('../threads/selectors/getThreadList');

var _getColoring = require('../selectors/widgetDataSelectors/getColoring');

var _getPotentialResponders = require('../responders/selectors/getPotentialResponders');

var _getChatHeadingConfig = require('../chat-heading-config/selectors/getChatHeadingConfig');

var _getInitialResponder = require('../responders/selectors/getInitialResponder');

var _ThreadActions = require('../threads/actions/ThreadActions');

var ThreadActions = _interopRequireWildcard(_ThreadActions);

var _navigateToExistingThread = require('../navigation/actions/navigateToExistingThread');

var _ThreadList = require('../threads/components/ThreadList');

var _ThreadList2 = _interopRequireDefault(_ThreadList);

var _LoadingState = require('../components/LoadingState');

var _LoadingState2 = _interopRequireDefault(_LoadingState);

var _VisitorWidgetContainer = require('../visitor-widget/containers/VisitorWidgetContainer');

var _VisitorWidgetContainer2 = _interopRequireDefault(_VisitorWidgetContainer);

var _getAgentRespondersList = require('../responders/selectors/getAgentRespondersList');

var _getBotResponder = require('../responders/selectors/getBotResponder');

var _RecordPropType = require('conversations-prop-types/prop-types/RecordPropType');

var _RecordPropType2 = _interopRequireDefault(_RecordPropType);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ThreadListContainer = _react2.default.createClass({
  displayName: 'ThreadListContainer',

  propTypes: {
    botResponder: (0, _RecordPropType2.default)('Responder'),
    browserWindowHeight: _react.PropTypes.number.isRequired,
    chatHeadingConfig: _ChatHeadingConfigPropType2.default.isRequired,
    coloring: (0, _RecordPropType2.default)('ColoringRecord'),
    fetchVisitorThreads: _react.PropTypes.func.isRequired,
    initialResponder: (0, _RecordPropType2.default)('Responder').isRequired,
    inline: _react.PropTypes.bool.isRequired,
    isOpen: _react.PropTypes.bool,
    launcherRef: _react.PropTypes.object,
    navigateToExistingThread: _react.PropTypes.func.isRequired,
    navigateToMostRecentThread: _react.PropTypes.func.isRequired,
    onUpdateOpened: _react.PropTypes.func.isRequired,
    onUpdateSize: _react.PropTypes.func.isRequired,
    potentialResponders: _react.PropTypes.instanceOf(_immutable.List),
    responders: _react.PropTypes.instanceOf(_immutable.List),
    threadList: _react.PropTypes.instanceOf(_immutable.List),
    threadListStatus: _react.PropTypes.oneOf(Object.keys(RequestStatusTypes)).isRequired,
    threads: _react.PropTypes.instanceOf(_immutable.Map)
  },

  componentDidMount: function componentDidMount() {
    if (this.props.threadListStatus !== RequestStatusTypes.SUCCEEDED) {
      this.props.fetchVisitorThreads();
    }
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    var _props = this.props,
        threadListStatus = _props.threadListStatus,
        navigateToMostRecentThread = _props.navigateToMostRecentThread;


    var hasReceivedThreads = threadListStatus !== RequestStatusTypes.SUCCEEDED && nextProps.threadListStatus === RequestStatusTypes.SUCCEEDED;

    if (hasReceivedThreads) {
      navigateToMostRecentThread();
    }
  },
  handleSelectThread: function handleSelectThread(channel) {
    var _props$threads$get = this.props.threads.get(channel),
        threadId = _props$threads$get.threadId;

    this.props.navigateToExistingThread({ threadId: threadId, channel: channel });
  },
  isLoading: function isLoading() {
    return this.props.threadListStatus !== RequestStatusTypes.SUCCEEDED;
  },
  renderLoadingState: function renderLoadingState() {
    return _react2.default.createElement(_LoadingState2.default, null);
  },
  renderThreadList: function renderThreadList() {
    return _react2.default.createElement(_ThreadList2.default, {
      coloring: this.props.coloring,
      threads: this.props.threads,
      threadList: this.props.threadList,
      potentialResponders: this.props.potentialResponders,
      chatHeadingConfig: this.props.chatHeadingConfig,
      initialResponder: this.props.initialResponder,
      onSelectThread: this.handleSelectThread,
      responders: this.props.responders,
      botResponder: this.props.botResponder
    });
  },
  render: function render() {
    var content = this.isLoading() ? this.renderLoadingState() : this.renderThreadList();

    return _react2.default.createElement(
      _VisitorWidgetContainer2.default,
      {
        browserWindowHeight: this.props.browserWindowHeight,
        inline: this.props.inline,
        isOpen: this.props.isOpen,
        launcherRef: this.props.launcherRef,
        onUpdateOpened: this.props.onUpdateOpened,
        onUpdateSize: this.props.onUpdateSize,
        viewingThreadList: true
      },
      content
    );
  }
});

exports.default = (0, _reactRedux.connect)(function (state) {
  var requestStatus = state.requestStatus;


  return {
    threadListStatus: requestStatus.threadListStatus,
    coloring: (0, _getColoring.getColoring)(state),
    threads: (0, _getThreads.getThreads)(state),
    threadList: (0, _getThreadList.getThreadList)(state),
    potentialResponders: (0, _getPotentialResponders.getPotentialResponders)(state),
    chatHeadingConfig: (0, _getChatHeadingConfig.getChatHeadingConfig)(state),
    initialResponder: (0, _getInitialResponder.getInitialResponder)(state),
    responders: (0, _getAgentRespondersList.getAgentRespondersList)(state),
    botResponder: (0, _getBotResponder.getBotResponder)(state)
  };
}, {
  fetchVisitorThreads: ThreadActions.fetchVisitorThreads,
  navigateToMostRecentThread: ThreadActions.navigateToMostRecentThread,
  navigateToExistingThread: _navigateToExistingThread.navigateToExistingThread
})(ThreadListContainer);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/containers/ThreadListContainer.js
// module id = 960
// module chunks = 2 3